// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRolloverClaimsPropertyDto
 */
export interface IRolloverClaimsPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IRolloverClaimsPropertyDto
     */
    rollover_claims_days_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IRolloverClaimsPropertyDto
     */
    rollover_claims_type?: IRolloverClaimsPropertyDtoRolloverClaimsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IRolloverClaimsPropertyDto
     */
    rollover_claims_type_state?: IRolloverClaimsPropertyDtoRolloverClaimsTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IRolloverClaimsPropertyDtoRolloverClaimsTypeEnum {
    ALLOW_PRIOR_YEAR_CLAIMS = 'ALLOW_PRIOR_YEAR_CLAIMS'
}
/**
* @export
* @enum {string}
*/
export enum IRolloverClaimsPropertyDtoRolloverClaimsTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IRolloverClaimsPropertyDto interface.
 */
export function instanceOfIRolloverClaimsPropertyDto(value: object): value is IRolloverClaimsPropertyDto {
    return true;
}

export function IRolloverClaimsPropertyDtoFromJSON(json: any): IRolloverClaimsPropertyDto {
    return IRolloverClaimsPropertyDtoFromJSONTyped(json, false);
}

export function IRolloverClaimsPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRolloverClaimsPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'rollover_claims_days_amount': json['rollover_claims_days_amount'] == null ? undefined : json['rollover_claims_days_amount'],
        'rollover_claims_type': json['rollover_claims_type'] == null ? undefined : json['rollover_claims_type'],
        'rollover_claims_type_state': json['rollover_claims_type_state'] == null ? undefined : json['rollover_claims_type_state'],
    };
}

export function IRolloverClaimsPropertyDtoToJSON(json: any): IRolloverClaimsPropertyDto {
    return IRolloverClaimsPropertyDtoToJSONTyped(json, false);
}

export function IRolloverClaimsPropertyDtoToJSONTyped(value?: IRolloverClaimsPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rollover_claims_days_amount': value['rollover_claims_days_amount'],
        'rollover_claims_type': value['rollover_claims_type'],
        'rollover_claims_type_state': value['rollover_claims_type_state'],
    };
}

